import { WinStreakSharePopup } from '../views/WinStreakSharePopup';
import { preloadLayoutsAssets } from '../../../views/preloadLayoutsAssets';
import type { WinStreakDependencies } from '../WinStreakController';

export async function openWinStreakSharePopup(dependencies: WinStreakDependencies): Promise<void> {
  const { observable, shareImage, popupsController } = dependencies;

  const winStreakState = observable.getValue().winStreakActiveEvent;

  if (!shareImage || !winStreakState || winStreakState.currentProgress === 0) return Promise.resolve();

  if (!(await preloadLayoutsAssets(WinStreakSharePopup.requiredLayouts, true))) return Promise.resolve();

  // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
  const { promise, resolve } = Promise.withResolvers<void>();

  const popup = new WinStreakSharePopup(winStreakState.currentProgress);

  popup.onClose.connect(async () => {
    await popupsController.closeActivePopup();
    resolve();
  });

  popup.onShare.connect(async (imagePromise): Promise<void> => {
    void shareImage?.(imagePromise);
  });

  void popupsController.addPopup(popup);

  return promise;
}
